import React, { useState, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from "../hooks/useAuthContext";



const Reset_Password_Continued = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const { dispatch } = useAuthContext();
    const [error, setError] = useState(null);




    const navigate = useNavigate();



    




    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== password2) {
            console.log("Passwords do not match");
            return;
        }
    
        const passwordValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordValidation.test(password)) {
            console.log("Password must be at least 8 characters long and contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol");
            setError("Password must be at least 8 characters long and contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol");
            return;
        }
    
        const newPassword = password;
        const email = localStorage.getItem('email');
        console.log("Email: " + email);
        console.log("New Password: " + newPassword);
    
        try {
            const response = await fetch("/api/user/resetPassword", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, newPassword }),
            });
            const json = await response.json();
            console.log("Response received:", json);
            navigate('/login')
    
            if (!response.ok) {
                console.log("Code incorrect or timed out");
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
        }
    };

    const checkCriteria = (password, password2) => {
        return {
            length: password.length >= 8,
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            number: /\d/.test(password),
            symbol: /[@$!%*?&]/.test(password),
            match: password.length > 0 && password === password2

        };
    };

    const criteria = checkCriteria(password, password2);
    const allCriteriaMet = criteria.length && criteria.lowercase && criteria.uppercase && criteria.number && criteria.symbol && criteria.match;

    





    return (
        <form className="login" onSubmit={handleSubmit}>
            
            <h3> Reset Password</h3>

            <label>New Password:</label>
            <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
            />
            <label>Retype Password:</label>
            <input
                type="password"
                onChange={(e) => setPassword2(e.target.value)}
                value={password2}
            />
            <div className="login_mechanisms">
                <ul className="password-requirements">
                    <li style={{ color: criteria.length ? 'green' : 'grey' }}>&#8226; At least 8 characters</li>
                    <li style={{ color: criteria.lowercase ? 'green' : 'grey' }}>&#8226; At least 1 lowercase letter</li>
                    <li style={{ color: criteria.uppercase ? 'green' : 'grey' }}>&#8226; At least 1 uppercase letter</li>
                    <li style={{ color: criteria.number ? 'green' : 'grey' }}>&#8226; At least 1 number</li>
                    <li style={{ color: criteria.symbol ? 'green' : 'grey' }}>&#8226; At least 1 symbol</li>
                    <li style={{ color: criteria.match ? 'green' : 'grey' }}>&#8226; Passwords match</li>


                </ul>
            </div>
            <button
                type="submit"
                className={`submit-button ${!allCriteriaMet ? 'disabled' : ''}`}
                disabled={!allCriteriaMet}
                style={{ backgroundColor: !allCriteriaMet ? 'lightgrey' : '#242424' }}
            >
                Submit New Password
            </button>


        </form>
    );
};

export default Reset_Password_Continued;